module.exports = __webpack_public_path__ + "img/1@2x.1e740eb5.png";